export enum PaymentMethod {
  UNINFORMED = {
    code: 'UNINFORMED',
    description: 'PAYMENT.UNINFORMED',
    descriptionPaid: 'PAYMENT.UNINFORMED',
  } as any,
  LOCAL_CREDIT_CARD = {
    code: 'LOCAL_CREDIT_CARD',
    description: 'PAYMENT.LOCAL_CREDIT_CARD',
    descriptionPaid: 'PAYMENT.PAID_LOCAL_CREDIT_CARD',
  } as any,
  LOCAL_DEBIT_CARD = {
    code: 'LOCAL_DEBIT_CARD',
    description: 'PAYMENT.LOCAL_DEBIT_CARD',
    descriptionPaid: 'PAYMENT.PAID_LOCAL_DEBIT_CARD',
  } as any,
  LOCAL_MONEY = {
    code: 'LOCAL_MONEY',
    description: 'PAYMENT.LOCAL_MONEY',
    descriptionPaid: 'PAYMENT.PAID_LOCAL_MONEY',
  } as any,
  LOCAL_MEAL_TICKET = {
    code: 'LOCAL_MEAL_TICKET',
    description: 'PAYMENT.LOCAL_MEAL_TICKET',
    descriptionPaid: 'PAYMENT.PAID_LOCAL_MEAL_TICKET',
  } as any,
  LOCAL_PIX = {
    code: 'LOCAL_PIX',
    description: 'PAYMENT.LOCAL_PIX',
    descriptionPaid: 'PAYMENT.PAID_LOCAL_PIX',
  } as any,
  APP_CREDIT_CARD = {
    code: 'APP_CREDIT_CARD',
    description: 'PAYMENT.APP_CREDIT_CARD',
    descriptionPaid: 'PAYMENT.PAID_APP_CREDIT_CARD',
  } as any,
  APP_DEBIT_CARD = {
    code: 'APP_DEBIT_CARD',
    description: 'PAYMENT.APP_DEBIT_CARD',
    descriptionPaid: 'PAYMENT.PAID_APP_DEBIT_CARD',
  } as any,
  APP_COUPON = {
    code: 'APP_COUPON',
    description: 'PAYMENT.APP_COUPON',
    descriptionPaid: 'PAYMENT.PAID_APP_COUPON',
  } as any,
  APP_MEAL_TICKET = {
    code: 'APP_MEAL_TICKET',
    description: 'PAYMENT.APP_MEAL_TICKET',
    descriptionPaid: 'PAYMENT.PAID_APP_MEAL_TICKET',
  } as any,
  APP_PIX = {
    code: 'APP_PIX',
    description: 'PAYMENT.APP_PIX',
    descriptionPaid: 'PAYMENT.PAID_APP_PIX',
  } as any,

  // Usado na reserva
  PIX = {
    code: 'PIX',
    description: 'PAYMENT.APP_PIX',
    descriptionPaid: 'PAYMENT.PAID_APP_PIX',
  } as any,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/payment-method.enum.ts